module.exports = __webpack_public_path__ + "static/media/autre-me.d13f83a9.jpg";